import React, { useState, useCallback } from 'react';
import { observer } from 'mobx-react';
import { Button, Grid } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import checklistIcon from 'core/assets/svg/check-list.svg';
import useSession from 'core/hooks/use-session';
import { Label } from 'core/components/label';
import { useStore } from 'core/store';
import { getFactorsImpactingPrice } from '../factors-impacting-price/helpers';
import FactorsImpactingPrice from '../factors-impacting-price';
import { MarketTierRating } from 'common/components/market-tier-rating';
import { checkIsFarmEnvironment } from 'common/helpers/environment-helpers';
const isFarmEnvironment = checkIsFarmEnvironment();
import { CardLine } from '../card-line';

import useStyles from './offer-details.styles';
import { supportingActionColor } from 'core/components/theme/theme-variant';

const OfferDetails = observer(() => {
  const { themeVariant } = useTheme();
  const classes = useStyles();
  const {
    offer: { marketTierRating, offer, selectedOption, loading }
  } = useStore();
  const { canSeeMarketTierCard } = useSession();
  const [showFactorsImpactingPriceModal, setShowFactorsImpactingPriceModal] = useState(false);

  const homeSelected = selectedOption?.includes('H');
  const autoSelected = selectedOption?.includes('A');
  const homeRejected = offer?.rejections?.some((rejection) => rejection.type === 'home');
  const autoRejected = offer?.rejections?.some((rejection) => rejection.type === 'auto');
  const factors = getFactorsImpactingPrice({
    offer,
    homeSelected,
    autoSelected,
    homeRejected,
    autoRejected
  });
  const toggleModal = useCallback(
    () => setShowFactorsImpactingPriceModal(!showFactorsImpactingPriceModal),
    [setShowFactorsImpactingPriceModal, showFactorsImpactingPriceModal]
  );

  if (loading) {
    return null;
  }

  return (
    <Grid className={classes.card}>
      <Button variant="contained" color={supportingActionColor(themeVariant)} disabled={!factors} onClick={toggleModal}>
        <Label className={classes.buttonLabel}>
          <img src={checklistIcon} alt="checklist" />
          {factors ? 'See reports & pricing details' : 'There are no additional factors impacting price'}
        </Label>
      </Button>

      {canSeeMarketTierCard && !isFarmEnvironment && (
        <>
          <CardLine className={classes.line} />
          <MarketTierRating marketTier={marketTierRating} />
        </>
      )}
      {showFactorsImpactingPriceModal && (
        <FactorsImpactingPrice open={showFactorsImpactingPriceModal} onClose={toggleModal} factors={factors} />
      )}
    </Grid>
  );
});

export default OfferDetails;
